<script setup lang="ts">
// FAQ items can be passed as props if needed to make it more dynamic
const faqItems: { question: string; answer: string }[] = [
  {
    question: 'How does MeetingHero.AI gather information?',
    answer:
      'Our platform uses advanced AI algorithms to aggregate publicly available data from trusted sources such as professional profiles, news outlets, and social media. It then synthesizes this data into concise insights tailored for your meetings.'
  },
  {
    question: 'Can I edit a scheduled meeting?',
    answer:
      'Yes, you can edit any meeting details by clicking on the meeting in your calendar and things will sync instantly.'
  },
  {
    question: 'What happens if I need to cancel a meeting?',
    answer:
      "You can cancel a meeting anytime from your calendar and things will sync instantly. The scheduled email will be cancelled as long as it hasn't been sent yet and the private calendar invite will be removed."
  },
  {
    question: 'Is there a limit to the number of participants?',
    answer: 'The number of participants depends on your calendar provider.'
  },
  {
    question: 'How frequently are the insights updated?',
    answer:
      'The insights are updated daily to ensure they are as accurate as possible. Some less frequently updated sources may not be updated as frequently.'
  },
  {
    question: 'What should I do if I have feedback or encounter issues?',
    answer:
      'We value your feedback! You can use the in-app feedback feature to share your thoughts or report any issues. You can also submit a ticket to our support team by clicking the "Submit Ticket" button in the support center.'
  }
]
</script>

<template>
  <div class="myCard q-pa-md">
    <h5 class="q-mt-none q-mb-md">Frequently Asked Questions</h5>
    <q-list padding>
      <q-expansion-item v-for="(item, index) in faqItems" :key="index" :label="item.question" class="q-mb-sm">
        <q-card>
          <q-card-section>
            {{ item.answer }}
          </q-card-section>
        </q-card>
      </q-expansion-item>
    </q-list>
  </div>
</template>

<style scoped>
h5 {
  margin: 0;
  font-weight: 500;
}
</style>
